import { Urgency } from "shared";
import { ReactComponent as CallAnAmbulanceIcon } from "../assets/callAnAmbulanceIcon.svg";
import * as React from "react";
import { ReactComponent as ConsultADoctorIcon } from "../assets/consultADoctorIcon.svg";
import { ReactComponent as SelfTreatmentIcon } from "../assets/selfTreatmentIcon.svg";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

export interface UrgencyData {
  title: string;
  text: string;
  generalText: string;
  icon: React.ReactNode;
  color: KahunColorMap;
  lightColor: KahunColorMap;
  level: number;
  selectorRange: [number, number];
  conceptName?: string;
}

export const URGENCY_DATA: Record<string, UrgencyData> = {
  [Urgency.MAJOR]: {
    level: 1,
    title: "TITLE_URGENT",
    text: "ADVICE_URGENT",
    generalText: "SEEK_URGENT",
    icon: <CallAnAmbulanceIcon />,
    color: KahunColorMap.Emergency,
    lightColor: KahunColorMap.EmergencyLight,
    selectorRange: [90, 100],
    conceptName: "Major Emergency",
  },
  [Urgency.EMERGENCY]: {
    level: 2,
    title: "TITLE_URGENT",
    text: "ADVICE_URGENT",
    generalText: "SEEK_URGENT",
    icon: <CallAnAmbulanceIcon />,
    color: KahunColorMap.Emergency,
    lightColor: KahunColorMap.EmergencyLight,
    selectorRange: [70, 89],
    conceptName: "Emergency",
  },
  [Urgency.URGENT]: {
    level: 3,
    title: "TITLE_MODERATE",
    text: "ADVICE_MODERATE",
    generalText: "SEEK_NOT_URGENT",
    icon: <ConsultADoctorIcon />,
    color: KahunColorMap.Urgent,
    lightColor: KahunColorMap.UrgentLight,
    selectorRange: [50, 69],
    conceptName: "Urgent",
  },
  [Urgency.SOMEWHAT_URGENT]: {
    level: 4,
    title: "TITLE_MODERATE",
    text: "ADVICE_MODERATE",
    generalText: "SEEK_NOT_URGENT",
    icon: <ConsultADoctorIcon />,
    color: KahunColorMap.Urgent,
    lightColor: KahunColorMap.UrgentLight,
    selectorRange: [40, 49],
    conceptName: "Somewhat Urgent",
  },
  [Urgency.NOT_URGENT]: {
    level: 5,
    title: "TITLE_NOT_URGENT",
    text: "ADVICE_NOT_URGENT",
    generalText: "SEEK_NOT_URGENT",
    icon: <SelfTreatmentIcon />,
    color: KahunColorMap.NotUrgent,
    lightColor: KahunColorMap.NotUrgentLight,
    selectorRange: [0, 39],
    conceptName: "Not Urgent",
  },
};
